export default function firstOrDefault<TItem>(items: TItem[], filter: (item: TItem) => boolean, defaultVal?: TItem | null) {
  let result: TItem | undefined | null = defaultVal;
  const filtered = items.filter(filter);
  console.log("FILTERED", filtered);
  if (filtered.length) {
    result = filtered[0];
  }
  return result;
}
